import _createClass from "/Users/dimitrisstefanakis/dev/ProductLabFrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _toConsumableArray from "/Users/dimitrisstefanakis/dev/ProductLabFrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/Users/dimitrisstefanakis/dev/ProductLabFrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/dimitrisstefanakis/dev/ProductLabFrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/dimitrisstefanakis/dev/ProductLabFrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/dimitrisstefanakis/dev/ProductLabFrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/dimitrisstefanakis/dev/ProductLabFrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/Users/dimitrisstefanakis/dev/ProductLabFrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

/*! Capacitor: https://capacitorjs.com/ - MIT License */
var createCapacitorPlatforms = function createCapacitorPlatforms(win) {
  var defaultPlatformMap = new Map();
  defaultPlatformMap.set('web', {
    name: 'web'
  });
  var capPlatforms = win.CapacitorPlatforms || {
    currentPlatform: {
      name: 'web'
    },
    platforms: defaultPlatformMap
  };

  var addPlatform = function addPlatform(name, platform) {
    capPlatforms.platforms.set(name, platform);
  };

  var setPlatform = function setPlatform(name) {
    if (capPlatforms.platforms.has(name)) {
      capPlatforms.currentPlatform = capPlatforms.platforms.get(name);
    }
  };

  capPlatforms.addPlatform = addPlatform;
  capPlatforms.setPlatform = setPlatform;
  return capPlatforms;
};

var initPlatforms = function initPlatforms(win) {
  return win.CapacitorPlatforms = createCapacitorPlatforms(win);
};
/**
 * @deprecated Set `CapacitorCustomPlatform` on the window object prior to runtime executing in the web app instead
 */


var CapacitorPlatforms = /*#__PURE__*/initPlatforms(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {});
/**
 * @deprecated Set `CapacitorCustomPlatform` on the window object prior to runtime executing in the web app instead
 */

var addPlatform = CapacitorPlatforms.addPlatform;
/**
 * @deprecated Set `CapacitorCustomPlatform` on the window object prior to runtime executing in the web app instead
 */

var setPlatform = CapacitorPlatforms.setPlatform;

var legacyRegisterWebPlugin = function legacyRegisterWebPlugin(cap, webPlugin) {
  var _a;

  var config = webPlugin.config;
  var Plugins = cap.Plugins;

  if (!config || !config.name) {
    // TODO: add link to upgrade guide
    throw new Error("Capacitor WebPlugin is using the deprecated \"registerWebPlugin()\" function, but without the config. Please use \"registerPlugin()\" instead to register this web plugin.\"");
  } // TODO: add link to upgrade guide


  console.warn("Capacitor plugin \"".concat(config.name, "\" is using the deprecated \"registerWebPlugin()\" function"));

  if (!Plugins[config.name] || ((_a = config === null || config === void 0 ? void 0 : config.platforms) === null || _a === void 0 ? void 0 : _a.includes(cap.getPlatform()))) {
    // Add the web plugin into the plugins registry if there already isn't
    // an existing one. If it doesn't already exist, that means
    // there's no existing native implementation for it.
    // - OR -
    // If we already have a plugin registered (meaning it was defined in the native layer),
    // then we should only overwrite it if the corresponding web plugin activates on
    // a certain platform. For example: Geolocation uses the WebPlugin on Android but not iOS
    Plugins[config.name] = webPlugin;
  }
};

var ExceptionCode;

(function (ExceptionCode) {
  /**
   * API is not implemented.
   *
   * This usually means the API can't be used because it is not implemented for
   * the current platform.
   */
  ExceptionCode["Unimplemented"] = "UNIMPLEMENTED";
  /**
   * API is not available.
   *
   * This means the API can't be used right now because:
   *   - it is currently missing a prerequisite, such as network connectivity
   *   - it requires a particular platform or browser version
   */

  ExceptionCode["Unavailable"] = "UNAVAILABLE";
})(ExceptionCode || (ExceptionCode = {}));

var CapacitorException = /*#__PURE__*/function (_Error) {
  _inherits(CapacitorException, _Error);

  var _super = _createSuper(CapacitorException);

  function CapacitorException(message, code) {
    var _this;

    _classCallCheck(this, CapacitorException);

    _this = _super.call(this, message);
    _this.message = message;
    _this.code = code;
    return _this;
  }

  return CapacitorException;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var getPlatformId = function getPlatformId(win) {
  var _a, _b;

  if (win === null || win === void 0 ? void 0 : win.androidBridge) {
    return 'android';
  } else if ((_b = (_a = win === null || win === void 0 ? void 0 : win.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.bridge) {
    return 'ios';
  } else {
    return 'web';
  }
};

var createCapacitor = function createCapacitor(win) {
  var _a, _b, _c, _d, _e;

  var capCustomPlatform = win.CapacitorCustomPlatform || null;
  var cap = win.Capacitor || {};
  var Plugins = cap.Plugins = cap.Plugins || {};
  /**
   * @deprecated Use `capCustomPlatform` instead, default functions like registerPlugin will function with the new object.
   */

  var capPlatforms = win.CapacitorPlatforms;

  var defaultGetPlatform = function defaultGetPlatform() {
    return capCustomPlatform !== null ? capCustomPlatform.name : getPlatformId(win);
  };

  var getPlatform = ((_a = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _a === void 0 ? void 0 : _a.getPlatform) || defaultGetPlatform;

  var defaultIsNativePlatform = function defaultIsNativePlatform() {
    return getPlatform() !== 'web';
  };

  var isNativePlatform = ((_b = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _b === void 0 ? void 0 : _b.isNativePlatform) || defaultIsNativePlatform;

  var defaultIsPluginAvailable = function defaultIsPluginAvailable(pluginName) {
    var plugin = registeredPlugins.get(pluginName);

    if (plugin === null || plugin === void 0 ? void 0 : plugin.platforms.has(getPlatform())) {
      // JS implementation available for the current platform.
      return true;
    }

    if (getPluginHeader(pluginName)) {
      // Native implementation available.
      return true;
    }

    return false;
  };

  var isPluginAvailable = ((_c = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _c === void 0 ? void 0 : _c.isPluginAvailable) || defaultIsPluginAvailable;

  var defaultGetPluginHeader = function defaultGetPluginHeader(pluginName) {
    var _a;

    return (_a = cap.PluginHeaders) === null || _a === void 0 ? void 0 : _a.find(function (h) {
      return h.name === pluginName;
    });
  };

  var getPluginHeader = ((_d = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _d === void 0 ? void 0 : _d.getPluginHeader) || defaultGetPluginHeader;

  var handleError = function handleError(err) {
    return win.console.error(err);
  };

  var pluginMethodNoop = function pluginMethodNoop(_target, prop, pluginName) {
    return Promise.reject("".concat(pluginName, " does not have an implementation of \"").concat(prop, "\"."));
  };

  var registeredPlugins = new Map();

  var defaultRegisterPlugin = function defaultRegisterPlugin(pluginName) {
    var jsImplementations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var registeredPlugin = registeredPlugins.get(pluginName);

    if (registeredPlugin) {
      console.warn("Capacitor plugin \"".concat(pluginName, "\" already registered. Cannot register plugins twice."));
      return registeredPlugin.proxy;
    }

    var platform = getPlatform();
    var pluginHeader = getPluginHeader(pluginName);
    var jsImplementation;

    var loadPluginImplementation = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!jsImplementation && platform in jsImplementations)) {
                  _context.next = 11;
                  break;
                }

                if (!(typeof jsImplementations[platform] === 'function')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return jsImplementations[platform]();

              case 4:
                _context.t0 = jsImplementation = _context.sent;
                _context.next = 8;
                break;

              case 7:
                _context.t0 = jsImplementation = jsImplementations[platform];

              case 8:
                jsImplementation = _context.t0;
                _context.next = 20;
                break;

              case 11:
                if (!(capCustomPlatform !== null && !jsImplementation && 'web' in jsImplementations)) {
                  _context.next = 20;
                  break;
                }

                if (!(typeof jsImplementations['web'] === 'function')) {
                  _context.next = 18;
                  break;
                }

                _context.next = 15;
                return jsImplementations['web']();

              case 15:
                _context.t1 = jsImplementation = _context.sent;
                _context.next = 19;
                break;

              case 18:
                _context.t1 = jsImplementation = jsImplementations['web'];

              case 19:
                jsImplementation = _context.t1;

              case 20:
                return _context.abrupt("return", jsImplementation);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function loadPluginImplementation() {
        return _ref.apply(this, arguments);
      };
    }();

    var createPluginMethod = function createPluginMethod(impl, prop) {
      var _a, _b;

      if (pluginHeader) {
        var methodHeader = pluginHeader === null || pluginHeader === void 0 ? void 0 : pluginHeader.methods.find(function (m) {
          return prop === m.name;
        });

        if (methodHeader) {
          if (methodHeader.rtype === 'promise') {
            return function (options) {
              return cap.nativePromise(pluginName, prop.toString(), options);
            };
          } else {
            return function (options, callback) {
              return cap.nativeCallback(pluginName, prop.toString(), options, callback);
            };
          }
        } else if (impl) {
          return (_a = impl[prop]) === null || _a === void 0 ? void 0 : _a.bind(impl);
        }
      } else if (impl) {
        return (_b = impl[prop]) === null || _b === void 0 ? void 0 : _b.bind(impl);
      } else {
        throw new CapacitorException("\"".concat(pluginName, "\" plugin is not implemented on ").concat(platform), ExceptionCode.Unimplemented);
      }
    };

    var createPluginMethodWrapper = function createPluginMethodWrapper(prop) {
      var remove;

      var wrapper = function wrapper() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var p = loadPluginImplementation().then(function (impl) {
          var fn = createPluginMethod(impl, prop);

          if (fn) {
            var _p = fn.apply(void 0, args);

            remove = _p === null || _p === void 0 ? void 0 : _p.remove;
            return _p;
          } else {
            throw new CapacitorException("\"".concat(pluginName, ".").concat(prop, "()\" is not implemented on ").concat(platform), ExceptionCode.Unimplemented);
          }
        });

        if (prop === 'addListener') {
          p.remove = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    return _context2.abrupt("return", remove());

                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));
        }

        return p;
      }; // Some flair ✨


      wrapper.toString = function () {
        return "".concat(prop.toString(), "() { [capacitor code] }");
      };

      Object.defineProperty(wrapper, 'name', {
        value: prop,
        writable: false,
        configurable: false
      });
      return wrapper;
    };

    var addListener = createPluginMethodWrapper('addListener');
    var removeListener = createPluginMethodWrapper('removeListener');

    var addListenerNative = function addListenerNative(eventName, callback) {
      var call = addListener({
        eventName: eventName
      }, callback);

      var remove = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var callbackId;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return call;

                case 2:
                  callbackId = _context3.sent;
                  removeListener({
                    eventName: eventName,
                    callbackId: callbackId
                  }, callback);

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function remove() {
          return _ref3.apply(this, arguments);
        };
      }();

      var p = new Promise(function (resolve) {
        return call.then(function () {
          return resolve({
            remove: remove
          });
        });
      });
      p.remove = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.warn("Using addListener() without 'await' is deprecated.");
                _context4.next = 3;
                return remove();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return p;
    };

    var proxy = new Proxy({}, {
      get: function get(_, prop) {
        switch (prop) {
          // https://github.com/facebook/react/issues/20030
          case '$$typeof':
            return undefined;

          case 'toJSON':
            return function () {
              return {};
            };

          case 'addListener':
            return pluginHeader ? addListenerNative : addListener;

          case 'removeListener':
            return removeListener;

          default:
            return createPluginMethodWrapper(prop);
        }
      }
    });
    Plugins[pluginName] = proxy;
    registeredPlugins.set(pluginName, {
      name: pluginName,
      proxy: proxy,
      platforms: new Set([].concat(_toConsumableArray(Object.keys(jsImplementations)), _toConsumableArray(pluginHeader ? [platform] : [])))
    });
    return proxy;
  };

  var registerPlugin = ((_e = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _e === void 0 ? void 0 : _e.registerPlugin) || defaultRegisterPlugin; // Add in convertFileSrc for web, it will already be available in native context

  if (!cap.convertFileSrc) {
    cap.convertFileSrc = function (filePath) {
      return filePath;
    };
  }

  cap.getPlatform = getPlatform;
  cap.handleError = handleError;
  cap.isNativePlatform = isNativePlatform;
  cap.isPluginAvailable = isPluginAvailable;
  cap.pluginMethodNoop = pluginMethodNoop;
  cap.registerPlugin = registerPlugin;
  cap.Exception = CapacitorException;
  cap.DEBUG = !!cap.DEBUG;
  cap.isLoggingEnabled = !!cap.isLoggingEnabled; // Deprecated props

  cap.platform = cap.getPlatform();
  cap.isNative = cap.isNativePlatform();
  return cap;
};

var initCapacitorGlobal = function initCapacitorGlobal(win) {
  return win.Capacitor = createCapacitor(win);
};

var Capacitor = /*#__PURE__*/initCapacitorGlobal(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {});
var registerPlugin = Capacitor.registerPlugin;
/**
 * @deprecated Provided for backwards compatibility for Capacitor v2 plugins.
 * Capacitor v3 plugins should import the plugin directly. This "Plugins"
 * export is deprecated in v3, and will be removed in v4.
 */

var Plugins = Capacitor.Plugins;
/**
 * Provided for backwards compatibility. Use the registerPlugin() API
 * instead, and provide the web plugin as the "web" implmenetation.
 * For example
 *
 * export const Example = registerPlugin('Example', {
 *   web: () => import('./web').then(m => new m.Example())
 * })
 *
 * @deprecated Deprecated in v3, will be removed from v4.
 */

var registerWebPlugin = function registerWebPlugin(plugin) {
  return legacyRegisterWebPlugin(Capacitor, plugin);
};
/**
 * Base class web plugins should extend.
 */


var WebPlugin = /*#__PURE__*/function () {
  function WebPlugin(config) {
    _classCallCheck(this, WebPlugin);

    this.listeners = {};
    this.windowListeners = {};

    if (config) {
      // TODO: add link to upgrade guide
      console.warn("Capacitor WebPlugin \"".concat(config.name, "\" config object was deprecated in v3 and will be removed in v4."));
      this.config = config;
    }
  }

  _createClass(WebPlugin, [{
    key: "addListener",
    value: function addListener(eventName, listenerFunc) {
      var _this2 = this;

      var listeners = this.listeners[eventName];

      if (!listeners) {
        this.listeners[eventName] = [];
      }

      this.listeners[eventName].push(listenerFunc); // If we haven't added a window listener for this event and it requires one,
      // go ahead and add it

      var windowListener = this.windowListeners[eventName];

      if (windowListener && !windowListener.registered) {
        this.addWindowListener(windowListener);
      }

      var remove = /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.abrupt("return", _this2.removeListener(eventName, listenerFunc));

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function remove() {
          return _ref5.apply(this, arguments);
        };
      }();

      var p = Promise.resolve({
        remove: remove
      });
      Object.defineProperty(p, 'remove', {
        value: function () {
          var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    console.warn("Using addListener() without 'await' is deprecated.");
                    _context6.next = 3;
                    return remove();

                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          }));

          function value() {
            return _value.apply(this, arguments);
          }

          return value;
        }()
      });
      return p;
    }
  }, {
    key: "removeAllListeners",
    value: function () {
      var _removeAllListeners = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var listener;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.listeners = {};

                for (listener in this.windowListeners) {
                  this.removeWindowListener(this.windowListeners[listener]);
                }

                this.windowListeners = {};

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function removeAllListeners() {
        return _removeAllListeners.apply(this, arguments);
      }

      return removeAllListeners;
    }()
  }, {
    key: "notifyListeners",
    value: function notifyListeners(eventName, data) {
      var listeners = this.listeners[eventName];

      if (listeners) {
        listeners.forEach(function (listener) {
          return listener(data);
        });
      }
    }
  }, {
    key: "hasListeners",
    value: function hasListeners(eventName) {
      return !!this.listeners[eventName].length;
    }
  }, {
    key: "registerWindowListener",
    value: function registerWindowListener(windowEventName, pluginEventName) {
      var _this3 = this;

      this.windowListeners[pluginEventName] = {
        registered: false,
        windowEventName: windowEventName,
        pluginEventName: pluginEventName,
        handler: function handler(event) {
          _this3.notifyListeners(pluginEventName, event);
        }
      };
    }
  }, {
    key: "unimplemented",
    value: function unimplemented() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'not implemented';
      return new Capacitor.Exception(msg, ExceptionCode.Unimplemented);
    }
  }, {
    key: "unavailable",
    value: function unavailable() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'not available';
      return new Capacitor.Exception(msg, ExceptionCode.Unavailable);
    }
  }, {
    key: "removeListener",
    value: function () {
      var _removeListener = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(eventName, listenerFunc) {
        var listeners, index;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                listeners = this.listeners[eventName];

                if (listeners) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt("return");

              case 3:
                index = listeners.indexOf(listenerFunc);
                this.listeners[eventName].splice(index, 1); // If there are no more listeners for this type of event,
                // remove the window listener

                if (!this.listeners[eventName].length) {
                  this.removeWindowListener(this.windowListeners[eventName]);
                }

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function removeListener(_x, _x2) {
        return _removeListener.apply(this, arguments);
      }

      return removeListener;
    }()
  }, {
    key: "addWindowListener",
    value: function addWindowListener(handle) {
      window.addEventListener(handle.windowEventName, handle.handler);
      handle.registered = true;
    }
  }, {
    key: "removeWindowListener",
    value: function removeWindowListener(handle) {
      if (!handle) {
        return;
      }

      window.removeEventListener(handle.windowEventName, handle.handler);
      handle.registered = false;
    }
  }]);

  return WebPlugin;
}();

var WebView = /*#__PURE__*/registerPlugin('WebView');
export { Capacitor, CapacitorException, CapacitorPlatforms, ExceptionCode, Plugins, WebPlugin, WebView, addPlatform, registerPlugin, registerWebPlugin, setPlatform };